module.exports = __webpack_public_path__ + "static/media/icons.bc60a8aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons.svg
// module id = 16
// module chunks = 0